import { j as d } from "./jsx-runtime-3tyXYecC.mjs";
import { D as P } from "./date-picker-calendar-single-Ce3WY92H.mjs";
import { g as v, u as f, a as x } from "./date-picker-utils-provider-CwC1AjFc.mjs";
const o = (e, r) => typeof r == "string" ? v(e, r) : void 0, i = (e, r) => e.format(r, "isoDate"), S = (e, r) => (n) => r(i(e, n)), g = (e, r) => (n, u, m) => {
  const l = u.filter((a) => a !== null).map((a) => a && i(e, a)), { day: s, onDayFocus: c, onDaySelect: t, ...D } = m, p = {
    day: i(e, s),
    onDayFocus: (a) => c && c(o(e, a)),
    onDaySelect: (a, y) => t(o(e, a), y),
    ...D
  };
  return r(n, l, p);
}, k = ({
  disabled: e,
  getDateDisabled: r,
  maxDate: n,
  minDate: u,
  onCancel: m,
  onChange: l,
  renderDate: s,
  value: c
}) => {
  const t = f();
  return /* @__PURE__ */ d.jsx(x, { children: /* @__PURE__ */ d.jsx(
    P,
    {
      disabled: e,
      getDateDisabled: r && S(t, r),
      maxDate: o(t, n),
      minDate: o(t, u),
      onChange: ({ value: D }) => l({ value: i(t, D) }),
      renderDate: s && g(t, s),
      value: o(t, c)
    }
  ) });
};
export {
  k as C
};
//# sourceMappingURL=calendar-D-LyW7Ov.mjs.map
